<template>
  <div class="container-fluid">

    <add-flag-history></add-flag-history>

    <table class="table table-hover table-bordered table-template-1 my-2 text-small">
      <thead>
      <tr>
        <th>#</th>
        <th>VESSEL NAME</th>
        <th>DATE FROM</th>
        <th>DATE TO</th>
        <th>FLAG</th>
        <th class="col-actions" style="width: 10%;">ACTION</th>
      </tr>
      </thead>

      <tbody>
      <tr v-if="isLoading">
        <td colspan="100%">
          <app-loading></app-loading>
        </td>
      </tr>
      <template v-else>
        <tr v-for="(vesselFlag, index) in vesselFlags" :key="vesselFlag.id">
          <td class="text-right">
            {{ index + 1 }}
          </td>
          <td class="text-center">{{ vesselFlag.vessel_name }}</td>
          <td class="text-center">
            <span v-if="vesselFlag.date_from">{{ vesselFlag.date_from | moment('D MMM YYYY') }}</span>
          </td>
          <td class="text-center">
            <span v-if="vesselFlag.date_to"> {{ vesselFlag.date_to | moment('D MMM YYYY') }} </span>
          </td>
          <td class="text-center">{{ vesselFlag.flagName }}</td>
          <td class="text-center">
            <template  v-if="(isSystemAdmin || isPrincipal || isPrincipalStaff || isDesignatedPrincipal) && !isKline">
              <button class="btn btn-sm btn-xs btn-warning mr-2 font-weight-bolder"
                      data-toggle="modal"
                      data-target="#view-vessel-flag"
                      @click="viewVesselFlag = vesselFlag"
              >
                <span class="fas fa-pencil-alt"></span>
                Edit
              </button>
              <button class="btn btn-sm btn-xs btn-danger mr-2 font-weight-bolder"
                      title="Delete This Vessel Flag Record"
                      @click="confirmDeleteVesselFlag(vesselFlag.id)"
              >
                <span class="fas fa-trash"></span>
              </button>
            </template>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
    <edit-flag-history :view-vessel-flag="viewVesselFlag"></edit-flag-history>
  </div>
</template>

<script>
/* eslint-disable */
import {vueAppMixin} from '@/mixins/vueAppMixin';
import {dataMixin} from '@/mixins/dataMixin';
import {gateMixin} from '@/mixins/gateMixin';
import {mapActions, mapGetters} from 'vuex';
import {formMixin} from '@/mixins/formMixin';

import AppLoading from '@/components/elements/AppLoading';
import EditFlagHistory
  from '@/components/sub_components/master_lists/vessels/vessel_show_components/vessel-flag/EditFlagHistory';
import AddFlagHistory
  from '@/components/sub_components/master_lists/vessels/vessel_show_components/vessel-flag/AddFlagHistory';

export default {
  name: 'FlagHistoryIndex',

  mixins: [vueAppMixin, formMixin, dataMixin, gateMixin],

  components: {AppLoading, EditFlagHistory, AddFlagHistory},

  data() {
    return {
      viewVesselFlag: {},
    };
  },

  methods: {
    ...mapActions([
      'getVesselFlags',
      'getCountryKeys',
      'deleteVesselFlag',
    ]),

    async confirmDeleteVesselFlag(vesselFlagId) {
      if (await this.confirmDeleteAlert()) {
        let deleteVesselFlag = await this.deleteVesselFlag({vesselFlagId: vesselFlagId});
        if (deleteVesselFlag) this.successAlert('Vessel Flag Record Successfully Deleted', 'DELETE');
      }
    },

  },

  computed: {
    ...mapGetters([
      'vesselFlags',
      'countryKeys',
      'vesselInfo',
    ]),
  },

  created() {
    this.getCountryKeys();
      this.getVesselFlags({vesselId: this.$route.params.id});

    // if (this.vesselInfo.id) {
    //   this.getVesselFlags({vesselId: this.vesselInfo.id});
    // }

  },

  watch: {
    // 'vesselInfo.id'() {
    //   this.getVesselFlags({vesselId: this.vesselInfo.id});
    // },

  },

};
</script>

<style scoped>
.nav-pills .nav-link {
  color: #555;
}

.nav-pills > li > a.active {
  background-color: #343a40;
  color: white;
}
</style>
